module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_7016.1bbac8bc.png";